import styled from 'styled-components'

export default styled.div`
  display: block;
  max-width: 1024px;
  margin: 0 auto;
  margin-bottom: 32px;
  padding: 0 16px;
`
